/* Nibec · Búsqueda por medida y rescate sin resultados (T-0854, 18-oct-2026, Bigbuda · Conversion Wise CW-NAV-2)
   Hallazgo: «180x90», «180 x 90» y «180×90» daban 4, 4 y 6 resultados (y «180*90» 9): el buscador de Shopify parte «×», «*» y las palabras
   sueltas en términos distintos. La gente busca por medida; la misma medida escrita distinto debe dar lo mismo.
   Qué hace (todo en el cliente, sin tocar flete, pago ni carrito):
   1. Normaliza la consulta ANTES de enviarla: x, X, ×, ✕, *, «por» y espacios entre números pasan a «180x90» (también «200 x 200 x 60»). Se aplica al enviar
      cualquier formulario de búsqueda, a las sugerencias con foto y precio (el buscador del encabezado) y a /search si llega con la medida escrita distinto.
   2. Sinónimos de catálogo SOLO cuando la búsqueda no da nada (closet → locker, anaquel → estante, tarima → pallet): se muestra una nota con lo que se buscó.
   3. Sin resultados: categorías del menú y botón «Cotizar por WhatsApp» con el mensaje ya armado (el clic usa conRef de nibec-cotizacion.js, que agrega los
      campos de la cotización formal).
   Medición (GA4 y dataLayer, como los demás eventos nibec_*): nibec_busqueda_enviar, nibec_busqueda_sin_resultados, nibec_busqueda_rescate_clic.
   Heatmap: data-hm-id busqueda-enviar, busqueda-sin-resultados-categoria y busqueda-sin-resultados-whatsapp.
   Interruptor: Configuración del tema › «Nibec · Búsqueda por medida». Apagado, el <script> no se carga y todo queda como antes.
   Sin animaciones de JS: solo CSS (assets/nibec-busqueda-medida.css), con prefers-reduced-motion respetado. */
(function () {
  'use strict';
  if (window.__nibecBusquedaMedida) return;
  window.__nibecBusquedaMedida = true;
  var SCRIPT = document.currentScript;
  var CFG = { wa: 'https://wa.me/56944549832', cats: [], css: '' };
  try {
    if (SCRIPT) {
      CFG.css = SCRIPT.getAttribute('data-css') || '';
      CFG.wa = (SCRIPT.getAttribute('data-wa') || CFG.wa).split('?')[0];
      CFG.cats = JSON.parse(SCRIPT.getAttribute('data-cats') || '[]') || [];
    }
  } catch (e) {}
  var WA_SVG = '<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.6.8-.8 1-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3a.5.5 0 0 0 0-.5l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.8 11.9 11.9 0 0 0 4.6 4c1.7.7 2.4.8 3.3.7a2.8 2.8 0 0 0 1.8-1.3 2.3 2.3 0 0 0 .2-1.3c-.1-.1-.3-.2-.6-.3z"/></svg>';

  /* ── 1. Normalización de medidas ─────────────────────────────────────────────────────────────── */
  function medida(q) {
    var s = String(q == null ? '' : q);
    // «180 cm x 90 cm» → «180x90cm»: la unidad pegada al número antes del separador sobra
    s = s.replace(/(\d)\s*cm\s*(?=(?:[xX×✕✖*]|por\b)\s*\d)/gi, '$1');
    // «180 por 90» → «180x90» (solo entre números)
    s = s.replace(/(\d)\s+por\s+(?=\d)/gi, '$1x');
    // x, X, ×, ✕, ✖ y * entre números, con o sin espacios → x
    s = s.replace(/(\d)\s*[xX×✕✖*]\s*(?=\d)/g, '$1x');
    // «180x90 cm» / «180x90cm» → «180x90»: el título trae la unidad en otro formato («40 cm», «40cm») y la palabra sola ensancha la búsqueda
    s = s.replace(/(\d+(?:[.,]\d+)?(?:x\d+(?:[.,]\d+)?)+)\s*(?:cm|cms|cent\u00edmetros)\b/gi, '$1');
    return s.replace(/\s{2,}/g, ' ').trim();
  }
  // Sinónimos de catálogo (solo si la consulta original no encontró nada). Los términos salen de la búsqueda real: «closet», «anaquel» y «tarima» dan 0 hoy.
  var ALIAS = [
    [/\b(closets?|guardarropas?)\b/gi, 'locker'],
    [/\b(anaquel(?:es)?)\b/gi, 'estante'],
    [/\b(tarimas?)\b/gi, 'pallet']
  ];
  function alias(q) {
    var s = String(q || ''), cambio = false;
    ALIAS.forEach(function (r) { var n = s.replace(r[0], r[1]); if (n !== s) { s = n; cambio = true; } });
    return cambio ? s : '';
  }

  /* ── Medición ────────────────────────────────────────────────────────────────────────────────── */
  function dispositivo() { return window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'celular' : 'computador'; }
  function medir(nombre, datos) {
    datos = datos || {};
    datos.dispositivo = dispositivo();
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(nombre, datos); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: nombre }, datos)); } catch (e) {}
  }

  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }

  /* ── 3. Bloque de rescate (categorías + WhatsApp), común a sugerencias y a /search ───────────── */
  function mensajeWa(t) {
    return 'Hola Nibec, busqué «' + t + '» en nibec.cl y no lo encontré. Necesito cotizar productos de esa medida o tipo.';
  }
  function rescate(t, origen, compacto) {
    var cont = el('div', 'nbm-rescate' + (compacto ? ' nbm-rescate--compacto' : ''));
    cont.setAttribute('data-nbm-rescate', '');
    if (CFG.cats.length) {
      if (!compacto) cont.appendChild(el('p', 'nbm-rescate__tit', 'O mira por categor\u00eda'));
      var lista = el('ul', 'nbm-chips');
      lista.setAttribute('role', 'list');
      CFG.cats.forEach(function (c) {
        if (!c || !c.t || !c.u) return;
        var li = el('li', 'nbm-chips__item'), a = el('a', 'nbm-chip', c.t);
        a.href = c.u;
        a.setAttribute('data-hm-id', 'busqueda-sin-resultados-categoria');
        a.addEventListener('click', function () { medir('nibec_busqueda_rescate_clic', { tipo: 'categoria', destino: c.u, termino: t, origen: origen }); });
        li.appendChild(a); lista.appendChild(li);
      });
      cont.appendChild(lista);
    }
    var wa = el('a', 'nbm-wa');
    wa.href = CFG.wa + '?text=' + encodeURIComponent(mensajeWa(t));
    wa.target = '_blank';
    wa.rel = 'noopener';
    wa.setAttribute('data-hm-id', 'busqueda-sin-resultados-whatsapp');
    var ic = el('span', 'nbm-wa__ic'); ic.setAttribute('aria-hidden', 'true'); ic.innerHTML = WA_SVG;
    wa.appendChild(ic);
    wa.appendChild(el('span', '', 'Cotizar por WhatsApp'));
    wa.appendChild(el('span', 'visually-hidden', ' (se abre WhatsApp)'));
    wa.addEventListener('click', function () { medir('nibec_busqueda_rescate_clic', { tipo: 'whatsapp', destino: 'wa.me', termino: t, origen: origen }); });
    cont.appendChild(wa);
    return cont;
  }

  function cargarCss() {
    if (!CFG.css || document.querySelector('link[data-nbm-css]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet'; l.href = CFG.css; l.setAttribute('data-nbm-css', '');
    document.head.appendChild(l);
  }

  /* ── 2. Sugerencias del encabezado (nibec-header-search): se envuelven termino() y pintar() ─── */
  function buscarSug(q, ctl) {
    var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    var params = new URLSearchParams({
      q: q,
      'resources[type]': 'product',
      'resources[limit]': '6',
      'resources[options][unavailable_products]': 'last',
      'resources[options][fields]': 'title,product_type,variants.sku,tag'
    });
    return fetch(base + '.json?' + params.toString(), { signal: ctl ? ctl.signal : undefined, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (d) { return (((d || {}).resources || {}).results || {}).products || []; });
  }

  function limpiarPanel(h) {
    var viejos = h.panel ? h.panel.querySelectorAll('[data-nbm-rescate], [data-nbm-nota]') : [];
    for (var i = 0; i < viejos.length; i++) viejos[i].parentNode.removeChild(viejos[i]);
  }

  function parchearSugerencias(C) {
    var proto = C.prototype;
    if (proto.__nbm) return;
    proto.__nbm = true;
    var pintarOriginal = proto.pintar;
    // La consulta que se envía y se muestra es la normalizada (cache, «Ver todos los resultados» y evento incluidos).
    proto.termino = function () { return medida((this.input && this.input.value) || ''); };
    proto.pintar = function (t, productos) {
      var h = this;
      limpiarPanel(h);
      if (productos.length === 0 && h.panel) {
        var alt = alias(t);
        if (alt && alt !== t && !h.__nbmAlt) {
          h.__nbmAlt = true;
          buscarSug(alt, null).then(function (r) {
            h.__nbmAlt = false;
            if (t !== h.termino()) return;
            if (r.length) {
              pintarOriginal.call(h, alt, r);
              var nota = el('p', 'nbm-nota', 'Mostrando «' + alt + '». No había resultados para «' + t + '».');
              nota.setAttribute('data-nbm-nota', '');
              h.panel.insertBefore(nota, h.lista);
              h.anunciar('Mostrando \u00ab' + alt + '\u00bb. No hab\u00eda resultados para \u00ab' + t + '\u00bb.');
              medir('nibec_busqueda_sin_resultados', { termino: t, origen: 'sugerencias', alternativa: alt, con_alternativa: 'si' });
            } else {
              pintarOriginal.call(h, t, []);
              vacioSugerencias(h, t, alt);
            }
          }).catch(function () { h.__nbmAlt = false; pintarOriginal.call(h, t, []); vacioSugerencias(h, t, alt); });
          return;
        }
      }
      pintarOriginal.call(h, t, productos);
      if (productos.length === 0) vacioSugerencias(h, t, '');
    };
  }
  function vacioSugerencias(h, t, alt) {
    if (!h.panel || !h.vacio) return;
    h.vacio.textContent = 'Sin resultados para «' + t + '». Prueba con una medida, como 180x90, o mira por categoría.';
    var r = rescate(t, 'sugerencias', true);
    h.panel.appendChild(r);
    if (h.__nbmUltimoVacio !== t) {
      h.__nbmUltimoVacio = t;
      medir('nibec_busqueda_sin_resultados', { termino: t, origen: 'sugerencias', alternativa: alt || '', con_alternativa: 'no' });
    }
  }

  /* ── Envío de cualquier formulario de búsqueda ──────────────────────────────────────────────── */
  function origenForm(f) {
    if (f.closest('nibec-header-search')) return 'encabezado';
    if (f.classList.contains('nibec-busq__form')) return 'resultados';
    if (f.classList.contains('nibec-drawer__search')) return 'menu';
    return 'otro';
  }
  function alEnviar(e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    var campo = f.querySelector('input[name="q"]');
    if (!campo) return;
    var original = (campo.value || '').trim();
    if (!original) return;
    var norm = medida(original);
    if (norm !== original) campo.value = norm;
    medir('nibec_busqueda_enviar', { termino: original, termino_normalizado: norm, normalizada: norm !== original ? 'si' : 'no', origen: origenForm(f) });
  }
  function marcarBotones() {
    var bs = document.querySelectorAll('nibec-header-search .nibec-header__search-btn, .nibec-busq__btn');
    for (var i = 0; i < bs.length; i++) if (!bs[i].hasAttribute('data-hm-id')) bs[i].setAttribute('data-hm-id', 'busqueda-enviar');
  }

  /* ── /search: normalizar la URL, sinónimos y estado sin resultados ──────────────────────────── */
  function paginaResultados() {
    if (!/^\/search\/?$/.test(location.pathname)) return;
    var p = new URLSearchParams(location.search), q = p.get('q') || '';
    if (!q) return;
    var norm = medida(q);
    if (norm !== q) { p.set('q', norm); location.replace(location.pathname + '?' + p.toString()); return; }
    var vacio = document.querySelector('.nibec-busq__vacio');
    var cab = document.querySelector('.nibec-busq__cabecera');
    var orig = p.get('nb_orig') || '';
    if (!vacio) {
      if (orig && cab && cab.parentNode) {
        var nota = el('p', 'nbm-nota nbm-nota--pagina', 'Mostrando resultados para «' + q + '». No había resultados para «' + orig + '».');
        nota.setAttribute('role', 'status');
        cab.parentNode.appendChild(nota);
      }
      return;
    }
    var alt = orig ? '' : alias(q);
    if (alt && alt !== q) {
      medir('nibec_busqueda_sin_resultados', { termino: q, origen: 'resultados', alternativa: alt, con_alternativa: 'si' });
      p.set('q', alt); p.set('nb_orig', q);
      location.replace(location.pathname + '?' + p.toString());
      return;
    }
    var t = orig || q;
    vacio.appendChild(rescate(t, 'resultados', false));
    medir('nibec_busqueda_sin_resultados', { termino: t, origen: 'resultados', alternativa: orig ? q : '', con_alternativa: 'no' });
  }

  function iniciar() {
    cargarCss();
    document.addEventListener('submit', alEnviar, true);
    marcarBotones();
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('nibec-header-search').then(function () {
        var C = customElements.get('nibec-header-search');
        if (C && C.prototype && C.prototype.pintar) parchearSugerencias(C);
      });
    }
    paginaResultados();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
